import React, { useState } from 'react';
import InternalBox from '../box/internal';
import { InternalButton } from '../button/internal';
import InternalFormField from '../form-field/internal';
import InternalModal from '../modal/internal';
import InternalTiles from '../tiles/internal';
import InternalSpaceBetween from '../space-between/internal';
import sidePositionIcon from './icons/side-position';
import bottomPositionIcon from './icons/bottom-icon';
export default (function (props) {
    var _a = useState(props.preferences.position), position = _a[0], setPosition = _a[1];
    var onCancel = function () {
        setPosition(props.preferences.position);
        props.onDismiss();
    };
    var onConfirm = function () {
        props.onConfirm({ position: position });
    };
    return (React.createElement(InternalModal, { visible: props.visible, onDismiss: props.onDismiss, header: props.i18nStrings.header, closeAriaLabel: props.i18nStrings.cancel, footer: React.createElement(InternalBox, { float: "right" },
            React.createElement(InternalSpaceBetween, { direction: "horizontal", size: "xs" },
                React.createElement(InternalButton, { onClick: onCancel, formAction: "none", variant: "link" }, props.i18nStrings.cancel),
                React.createElement(InternalButton, { onClick: onConfirm, variant: "primary" }, props.i18nStrings.confirm))), __internalRootRef: props.__internalRootRef },
        React.createElement(InternalFormField, { label: props.i18nStrings.positionLabel, description: props.i18nStrings.positionDescription },
            React.createElement(InternalTiles, { onChange: function (e) { return setPosition(e.detail.value); }, value: position, columns: 2, items: [
                    {
                        label: props.i18nStrings.positionBottom,
                        image: bottomPositionIcon,
                        value: 'bottom'
                    },
                    {
                        label: props.i18nStrings.positionSide,
                        image: sidePositionIcon,
                        value: 'side'
                    }
                ] }))));
});
//# sourceMappingURL=preferences-modal.js.map